import { Index as MobileReports } from "./devices/Index"
import { Index as DesktopReports } from "./desktop/Index"
import { VM } from "../../../core/VM"
import { useContext, useEffect } from "react"
import { ToolContext } from "../../../core/context/ToolContext"

import { FeatureIdState } from "../toolUsage/global/GlobalFcn"
import { CreateFeatureLogs } from "../global/API"

const view = VM()

export const Reports = ({match}) => { 
    const {tool_state}= useContext(ToolContext)
    const {__SESSION} = tool_state

    const tool_id =  process.env.REACT_APP_TID_BIZ;

    const SendFeatureLogs = async()=>{
        let body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState('reports')}`,
            feature_id: `${FeatureIdState('reports')}`,
            feature_name: "reports",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2
        }
        await CreateFeatureLogs(body)
    }

    useEffect(() => {
        SendFeatureLogs()
        //eslint-disable-next-line
    }, []);


    return (
        view === '' ? 
            // DESKTOP
            <DesktopReports match={match}/>
        :  
            // MOBILE
            <MobileReports match={match}/>
    )
}
